import { fetchAPI } from '@/api'
import type {
  AdminSharedDictionaryResponse,
  GetAdminSharedDictionaryStatusEnum,
  SharedEntryDecisionResponse,
} from '@/api/generated'

// Aliased, not re-declared: the generated enum tracks the backend's own literal.
export type SharedDictionaryStatus = GetAdminSharedDictionaryStatusEnum

export interface SharedDictionaryQuery {
  /** Omitted spans both kinds — the approval queue is one list. */
  isSnippet?: boolean
  search: string
  limit: number
  offset: number
  /** Part of the query object, so it lands in the React Query key rather than beside it. */
  status?: SharedDictionaryStatus
}

// Enterprise-scoped, not caller-scoped: `/dictionary/shared` returns org-wide rows plus the
// caller's own team, so an admin reading it sees nothing from any other department.
export async function getAdminSharedDictionary(query: SharedDictionaryQuery, signal?: AbortSignal) {
  return fetchAPI<AdminSharedDictionaryResponse>({
    method: 'GET',
    url: '/api/v1/dictionary/admin/shared',
    // The enterprise comes from the caller's token; there is no id to pass here.
    params: {
      is_snippet: query.isSnippet,
      search: query.search || undefined,
      limit: query.limit,
      offset: query.offset,
      status: query.status,
    },
    signal,
  })
}

export async function approveSharedEntry(wordId: string) {
  return fetchAPI<SharedEntryDecisionResponse>({
    method: 'POST',
    url: `/api/v1/dictionary/admin/shared/${wordId}/approve`,
  })
}

// Hard-deletes the row server-side: the word frees up for resubmission and no trace is kept.
export async function rejectSharedEntry(wordId: string) {
  return fetchAPI<SharedEntryDecisionResponse>({
    method: 'POST',
    url: `/api/v1/dictionary/admin/shared/${wordId}/reject`,
  })
}
